/**
 * Auth API calls, mapping 1:1 to the Django endpoints in api/urls.py.
 */
import api from './client';

/** Prime the csrftoken cookie. Call once on app load before any POST. */
export const fetchCsrf = () => api.get('/api/auth/csrf/');

/** Returns { user } where user is the current account or null. */
export const fetchMe = () => api.get('/api/auth/me/');

/** { name, email, password } -> { user }. Logs the user in on success. */
export const register = (payload) => api.post('/api/auth/register/', payload);

/** { email, password } -> { user }. */
export const login = (payload) => api.post('/api/auth/login/', payload);

/** Ends the session. */
export const logout = () => api.post('/api/auth/logout/');

/** { email } -> { ok }. Same response whether or not the account exists. */
export const requestPasswordReset = (payload) => api.post('/api/auth/password-reset/', payload);

/** { uid, token } -> { ok }, or an error if the link is invalid/expired/used. Doesn't use the link up. */
export const checkPasswordResetLink = (payload) => api.post('/api/auth/password-reset/check/', payload);

/** { uid, token, password } -> { ok }. uid/token come from the reset email link. */
export const confirmPasswordReset = (payload) => api.post('/api/auth/password-reset/confirm/', payload);
